<!-- Page Size Dropdown -->
<div class="d-flex align-items-center justify-content-end">
  <div class="d-flex align-items-center">
    <label for="pagesize" class="me-2 text-nowrap">Records per page</label>
    <select class="form-select" id="pagesize" [(ngModel)]="pageSize" (change)="onPageSizeChange($event)">
      <option *ngFor="let size of pageSizes" [value]="size">{{ size }}</option>
    </select>
  </div>

  <ul class="pagination justify-content-end ms-2" *ngIf="totalPages > 1">
    <li class="page-item">
      <button tabindex="-1" [disabled]="currentPage === 1" class="page-link" (click)="previousPage()">Previous</button>
    </li>

    <li class="page-item" *ngFor="let page of getPageNumbers()">
      <!-- Show ellipsis for -1 -->
      <ng-container *ngIf="page === -1">
        <li class="disabled">
          <button class="page-link">...</button>
        </li>
      </ng-container>

      <ng-container *ngIf="page !== -1">
        <button class="page-link" [class.active]="page === currentPage" (click)="goToPage(page)">
          {{ page }}
        </button>
      </ng-container>
    </li>

    <li class="page-item">
      <button tabindex="-1" [disabled]="currentPage === totalPages" class="page-link" (click)="nextPage()">Next</button>
    </li>
  </ul>
</div>
